import React from 'react';

import { VIconsType } from './IconsType';
import { IconsComp } from './styles';
import '../../../../assets/icons/style.scss';

interface IVIcons {
  fill?: string;
  opacity?: number;
  iconSize?: number;
  margin?: string;
  rotate?: string;
  iconName: VIconsType;
}

const VIcon = (props: IVIcons) => {
  return (
    <IconsComp {...props}>
      <span className={`icon-${props.iconName}`} />
    </IconsComp>
  );
};

export default VIcon;
